export default __webpack_public_path__ + "img/producto-800.ff3c248c.jpg";